import { USER_TYPES } from 'constants/enum';
import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();

/** Agency dashboard URL when user is admin with an agency account id; otherwise null. */
export function getAgencyAdminLandingPath(user) {
  if (
    !user ||
    user.Position_at_Agency !== USER_TYPES.ADMIN ||
    !user.Account_Name?.id
  ) {
    return null;
  }
  if (company === 'sunshine') {
    return `/agencies/${user.Account_Name.id}`;
  }
  return `/agency/dashboard/${user.Account_Name.id}`;
}

export function getDefaultAuthenticatedPath(user) {
  return getAgencyAdminLandingPath(user) ?? '/home';
}
